// extracted by mini-css-extract-plugin
export default {"post-likes":"post-likes__2QKcW","user-link":"user-link__3lAXV"};